import { useEffect, useState, useRef } from 'react';

const team = [
  {
    name: 'Ernie Tan',
    role: 'CEO & Co-Founder',
    bio: 'Accomplished IT expert with background in computer science and IT infrastructure. Leads strategic vision and product direction.',
    image: null,
  },
  {
    name: 'Wilson Ong',
    role: 'CFO & Co-Founder',
    bio: 'Strong financial acumen and operational management expertise. Oversees financial planning, investor relations, and business development.',
    image: null,
  },
  {
    name: 'Maslena ZA',
    role: 'CPO & Co-Founder',
    bio: 'Seasoned software development specialist. Oversees product strategy and delivery, focusing on user-centric platforms.',
    image: null,
  },
  {
    name: 'Ernesto Pama Jr.',
    role: 'CTO & Co-Founder',
    bio: 'Leads technical architecture and engineering operations. Extensive experience in cloud infrastructure and AI integration.',
    image: null,
  },
  {
    name: 'Kevin Chan',
    role: 'Head of Business Development',
    bio: 'Results-driven professional building strategic partnerships and expanding market reach to drive revenue growth.',
    image: null,
  },
];

export default function TeamSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="team"
      ref={sectionRef}
      data-testid="team-section"
      className="py-24 sm:py-32 bg-[#0D1321] relative overflow-hidden"
    >
      {/* Circuit Board Texture Overlay */}
      <img
        src="https://static.prod-images.emergentagent.com/jobs/651541d7-5e6b-42ae-bbbb-a15776d2b14a/images/e4999b22e6e96b63f63379e586d4e089214cb10290beac1b50287d8c22ef2507.png"
        alt=""
        loading="lazy"
        decoding="async"
        className="circuit-overlay"
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-xs tracking-[0.2em] uppercase font-semibold mb-4">
            Leadership
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white">
            Meet Our Team
          </h2>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div
              key={member.name}
              data-testid={`team-card-${index}`}
              className={`glass-card rounded-2xl p-6 text-center reveal ${
                isVisible ? 'visible' : ''
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <h3 className="text-xl font-semibold text-white mb-1">{member.name}</h3>
              <p className="text-[#F5A623] text-sm font-medium">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
